import React from 'react';
import { observer } from 'mobx-react';
import PasswordConfirmComponent from './Password-confirm.component';
import usePasswordConfirm from './usePasswordConfirm';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, lang, handlers } = usePasswordConfirm(onClose);

    return (
        <>
            <PasswordConfirmComponent
                lang={lang.lang}
                loading={store.confirmPasswordRecoveryLoading}
                code={state.code}
                codeError={state.codeError}
                confirmError={store.confirmError}
                serverError={store.serverError}
                password={state.password}
                passwordError={state.passwordError}
                passwordConfirm={state.passwordConfirm}
                passwordConfirmError={state.passwordConfirmError}
                sendedAgain={store.sendedAgain}
                timeToRequestAgain={store.timeToRequestAgain}
                isAllowedToRequestAgain={store.isAllowedToRequestAgain}
                onCodeChange={handlers.handleCodeChange}
                onPasswordChange={handlers.handlePasswordChange}
                onPasswordConfirmChange={handlers.handlePasswordConfirmChange}
                onConfirmClick={handlers.handleConfirmClick}
                onRequestConfirmClick={handlers.handleRequestConfirmClick}
                onInputClick={handlers.handleInputClick}
                onBackClick={handlers.handleBackClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const PasswordConfirmContainer = observer(Container);

export default PasswordConfirmContainer;
